/* ONE MENU ENTRY, THE SCREENS AS TABS INSIDE IT — Jay Jung, 2026-10-21: "Now menu bar is too long … unify
   request/approval in 1 menu and split inside (simplify the menu bar)". Max: "okie làm nhé".

   This list is read by BOTH the sidebar (one entry per module, opening the first tab the reader may open)
   and the tab strip at the top of each screen (ModuleTabs.jsx). One list, so the menu and the strip cannot
   come to disagree about which screens belong together or who sees which.

   NOTHING ABOUT ACCESS CHANGES. A tab is drawn by the same grant that drew its menu entry before, every
   route keeps its own ProtectedRoute, and every path is unchanged — so the links in mails already sent
   (/courier-approval?no=…, /gtm-approval/GTM-26-008, /sales/pricing-approval?open=…) still open their screen. */

// Build-time switches, as in Header.jsx: the value is baked in and cannot change while the page runs.
const GTM_ON = process.env.REACT_APP_GTM === '1';
const COURIER_ON = process.env.REACT_APP_COURIER === '1';
const PRICING_APPROVAL_ON = process.env.REACT_APP_PRICING_APPROVAL === '1';

export const MODULES = {
    courier: {
        labelKey: 'nav.courier',
        tabs: [
            { key: 'requests', labelKey: 'nav.courierRequests', path: '/courier', show: (can) => COURIER_ON && can('courier_request') },
            { key: 'approval', labelKey: 'nav.courierApproval', path: '/courier-approval', show: (can) => COURIER_ON && can('courier_approval') },
        ],
    },
    pricing: {
        labelKey: 'nav.collabPricing',
        tabs: [
            { key: 'calculator', labelKey: 'nav.pricingCalculator', path: '/sales/pricing-calculator', show: (can) => can('collab_pricing') },
            { key: 'approval', labelKey: 'nav.pricingApproval', path: '/sales/pricing-approval', show: (can) => PRICING_APPROVAL_ON && can('pricing_approval') },
            { key: 'sheets', labelKey: 'nav.benchmarkLibrary', path: '/sales/inline-cost-sheets', show: (can) => can('collab_pricing') },
        ],
    },
    gtm: {
        labelKey: 'nav.gtmProgrammes',
        tabs: [
            { key: 'programmes', labelKey: 'nav.gtmProgrammes', path: '/gtm', show: (can) => GTM_ON && can('gtm_programme') },
            { key: 'approval', labelKey: 'nav.gtmApproval', path: '/gtm-approval', show: (can) => GTM_ON && can('gtm_approval') },
            { key: 'tracker', labelKey: 'nav.gtmTracker', path: '/gtm-tracker', show: (can) => GTM_ON && (can('gtm_programme') || can('gtm_approval')) },
        ],
    },
};

export const visibleTabs = (moduleKey, can) => MODULES[moduleKey].tabs.filter((tab) => tab.show(can));

/* By SEGMENT, not by prefix: '/gtm-approval' starts with '/gtm', so a prefix test would light Programmes
   on the approver's screen. A programme's own page ('/gtm/GTM-26-001') still belongs to its list. */
export const tabActive = (tab, pathname) => pathname === tab.path || pathname.startsWith(`${tab.path}/`);

/* The sidebar's entry for a module: its name, the first screen the reader may open, and every path that
   should light it. Null when the reader may open none of them. */
export const moduleMenuItem = (moduleKey, can, t) => {
    const tabs = visibleTabs(moduleKey, can);
    if (!tabs.length) return null;
    /* `menuKey` names the ENTRY, not the screen it opens: which screen that is depends on the reader's grants, and a
       person's own menu order (menuOrder.js) has to find the entry whichever it is. */
    return { label: t(MODULES[moduleKey].labelKey), path: tabs[0].path, match: tabs, menuKey: `mod:${moduleKey}` };
};
